const ProductsIcon = () => {
  return (
    <svg
      width="155"
      height="163"
      viewBox="0 0 155 163"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.4318 0.789936C78.0082 0.222872 79.7257 0.22369 81.3015 0.792261L120.125 14.8003V71.5415L154.929 84.2795V139.162C154.929 142.089 153.279 144.752 150.696 145.993L116.072 162.636L78.2547 147.676L43.4991 162.629L5.06972 146.008C2.34544 144.83 0.574219 142.091 0.574219 139.057V85.3034L37.4934 70.7185V14.7977L76.4318 0.789936ZM41.1336 77.3628L14.3465 87.9451L43.4534 99.7914L68.6196 88.7973L41.1336 77.3628ZM74.5867 83.1406L75.1591 34.0169L44.8437 22.8352V70.7672L74.5867 83.1406ZM52.1542 17.5164L78.8634 27.368L105.493 17.5164L78.8634 7.90803L52.1542 17.5164ZM112.775 22.8406L82.5096 34.0371L81.9359 83.273L112.775 71.5739V22.8406ZM116.472 78.2128L89.3483 88.5027L116.308 97.5938L140.993 87.1871L116.472 78.2128ZM147.579 92.5651L120.102 104.149L119.661 152.581L147.579 139.162V92.5651ZM112.306 153.062L112.75 104.333L81.8722 93.9212V141.023L112.306 153.062ZM74.522 141.103V94.4166L47.1779 106.362V152.868L74.522 141.103ZM39.8277 152.856V106.43L7.92444 93.4457V139.057L39.8277 152.856Z"
        fill="black"
      />
    </svg>
  );
};

export default ProductsIcon;
